export enum ErrorCode {
  NONE = null,
  ORGANISATION_DATA = 'ORGANISATION_DATA',
  USER_DATA = 'USER_DATA',
  PAYMENT_METHODS_CONFIG = 'PAYMENT_METHODS_CONFIG',
  CUSTOMER_PAYMENT_DATA = 'CUSTOMER_PAYMENT_DATA',
  REFERRAL_PARTNER_LIST = 'REFERRAL_PARTNER_LIST',
  CUSTOMER_RZ_LIST = 'CUSTOMER_RZ_LIST',
}
